export const ArrowGoBackGlobal = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M10 13.3334C9.82936 13.3334 9.65867 13.268 9.52867 13.138L4.862 8.47138C4.60134 8.21071 4.60134 7.78934 4.862 7.52867L9.52867 2.862C9.78934 2.60134 10.2107 2.60134 10.4714 2.862C10.732 3.12267 10.732 3.54405 10.4714 3.80471L6.27607 8.00002L10.4714 12.1953C10.732 12.456 10.732 12.8774 10.4714 13.138C10.3414 13.268 10.1707 13.3334 10 13.3334Z"
        fill="currentColor"
      ></path>
    </svg>
  )
}
